import toast from 'jquery-toast-plugin';

/*
 * 採用コース
 */
if (($('#career-table .sort-btn').length)||($('#occupation-table .sort-btn').length)||($('#product-table .sort-btn').length)) {

jQuery(function () {
    var sort_target = '';
    if ($('#career-table').length) {
      sort_target = 'careers';
    } else if($('#occupation-table').length){
      sort_target = 'occupations';
    } else if($('#product-table').length){
      sort_target = 'products';
    }
  $(document).on('click','.sort-btn', function(){
    var tr = $(this).closest('tr');
    var id = $(tr).data('id');
    var order = $(this).data('order');
    var target_tr = '';
    if(order == 'up'){
      target_tr = $(tr).prev('tr');
    }else{
      target_tr = $(tr).next('tr');
    }
    if(target_tr == 'undefined'){
      return false;
    }
    var target_id = $(target_tr).data('id');
    
    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });
    $.ajax({
      url: '/ajax/'+ sort_target +'/sort',
      type: 'POST',
      dataType: 'json',
      data: {
        'id': id,
        'target_id': target_id
      }

    })
      // Ajaxリクエストが成功した時発動
      .done((data) => {
        if (data['result'] == 'ok') {
          if(order == 'up'){
            upList(this);
          }else{
            downList(this);
            
          }
            
          $.toast({
            heading: 'データ順を変更しました',
            text: 'データ順を変更しました',
            showHideTransition: 'slide',
            icon: 'success',
            position: 'bottom-right',
            hideAfter: 6000
          });
        } else if (data['result'] == 'nodeta') {

          $.toast({
            heading: '対象データがありません',
            text: '対象データがありません',
            showHideTransition: 'slide',
            icon: 'success',
            position: 'bottom-right',
            hideAfter: 6000
          });

        } else if (data['result'] == 'ng') {

          $.toast({
            heading: 'データ順の変更に失敗しました',
            text: 'お手数ですが、再度お試しください',
            showHideTransition: 'slide',
            icon: 'error',
            position: 'bottom-right',
            hideAfter: 6000
          });

        }

      })
      // Ajaxリクエストが失敗した時発動
      .fail((data) => {

        $.toast({
          heading: 'データ順の変更に失敗しました',
          text: 'お手数ですが、再度お試しください',
          showHideTransition: 'slide',
          icon: 'error',
          position: 'bottom-right',
          hideAfter: 6000
        });
      })
      // Ajaxリクエストが成功・失敗どちらでも発動
      .always((data) => {

      });
  });    
    // 行を一つ上に移動させる
  function upList(obj) {
    let $row = $(obj).closest("tr");
    let $row_prev = $row.prev("tr");
    if ($row.prev.length) {
      $row.insertBefore($row_prev);
    }
  }    
  // 行を一つ下に移動させる
  function downList(obj){
    let $row = $(obj).closest("tr");
    let $row_next = $row.next("tr");
    if ($row.next.length) {
      $row.insertAfter($row_next);
    }
  }    
});
}